import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad198444"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-details-table" }
const _hoisted_2 = {
  key: 0,
  class: "section-title"
}
const _hoisted_3 = { class: "table-wrapper" }
const _hoisted_4 = { class: "details-table" }
const _hoisted_5 = ["onDblclick"]
const _hoisted_6 = { class: "name-cell" }
const _hoisted_7 = { class: "dividend-cell" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "empty-row"
}
const _hoisted_10 = {
  colspan: "11",
  class: "empty-cell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockCodeDisplay = _resolveComponent("StockCodeDisplay")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.t('common.title')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.sequence')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.code')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.name')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.simulatedReturn')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.currentPrice')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.cost')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.holdingPercentage')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.annualizedDividendYield')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.openingDate')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.dividend')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.t('tableHeaders.operation')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (position) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: position.code,
              class: "table-row",
              onDblclick: ($event: any) => (_ctx.handleRowDoubleClick(position))
            }, [
              _createElementVNode("td", null, _toDisplayString(position.sequence), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_StockCodeDisplay, {
                  symbol: position.symbol,
                  market: position.market,
                  "hk-delay": _ctx.hkDelay,
                  "us-delay": _ctx.usDelay,
                  theme: _ctx.theme
                }, null, 8, ["symbol", "market", "hk-delay", "us-delay", "theme"])
              ]),
              _createElementVNode("td", _hoisted_6, _toDisplayString(position.name), 1),
              _createElementVNode("td", {
                style: _normalizeStyle({ color: _ctx.getReturnColor(position.simulatedReturn) })
              }, _toDisplayString(_ctx.formatPercentage(position.simulatedReturn)), 5),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(position.currentPrice, 3)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(position.cost, 3)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatPercentagePlain(position.holdingPercentage)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatPercentagePlain(position.annualizedDividendYield)), 1),
              _createElementVNode("td", null, _toDisplayString(position.openingDate), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(position.latestDividendContent || '--'), 1),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "trade-btn",
                  onClick: ($event: any) => (_ctx.handleOrderClick(position))
                }, _toDisplayString(_ctx.t('common.trade')), 9, _hoisted_8)
              ])
            ], 40, _hoisted_5))
          }), 128)),
          (_ctx.positions.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(_component_Nodata, {
                    mode: "vertical",
                    customdesc: _ctx.t('common.noData')
                  }, null, 8, ["customdesc"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}